import { useAxios } from '@/composables/use-axios';
import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin(() => {
  useAxios();
});
